// Buy Modal — two books, format selection, cart add
(function() {
  var modal = document.getElementById('hh-modal');
  var backdrop = document.getElementById('hh-modal-backdrop');
  if (!modal || !backdrop) return;

  var book = 'hoots'; // Study Turtle removed - Happy Hoots only
  var plan = 'print';

  var bookTiles = modal.querySelectorAll('.book-tile');
  var formatTiles = modal.querySelectorAll('.format-tile');
  var priceDisplay = document.getElementById('modal-price');
  var impactDisplay = document.getElementById('modal-impact');
  var ctaBtn = modal.querySelector('.modal-cta-btn');
  var hootsPanel = document.getElementById('modal-benefits-hoots');
  var turtlePanel = document.getElementById('modal-benefits-turtle');

  var variants = {
    'hoots-digital': modal.dataset.hootsDigital,
    'hoots-print': modal.dataset.hootsPrint,
    'turtle-digital': modal.dataset.turtleDigital,
    'turtle-print': modal.dataset.turtlePrint
  };

  function update() {
    bookTiles.forEach(function(t) { t.classList.toggle('active', t.dataset.bookSelect === book); });
    formatTiles.forEach(function(t) { t.classList.toggle('active', t.dataset.plan === plan); });
    if (hootsPanel) hootsPanel.style.display = book === 'hoots' ? '' : 'none';
    if (turtlePanel) turtlePanel.style.display = book === 'turtle' ? '' : 'none';

    var charEmoji = book === 'hoots' ? '🦉' : '🐢';
    var impactMsg = book === 'hoots'
      ? '🌳 One tree planted with every copy.'
      : '🐢 Helps remove ocean plastic with every copy.';

    if (plan === 'digital') {
      priceDisplay.innerHTML = '$5.00<small> one-time</small>';
      ctaBtn.textContent = 'Get the Digital eBook ' + charEmoji;
    } else {
      priceDisplay.innerHTML = '$11.99<small> + $1.99 shipping</small>';
      ctaBtn.textContent = 'Get the Paperback + eBook ' + charEmoji;
    }
    impactDisplay.textContent = impactMsg;
  }

  bookTiles.forEach(function(t) {
    t.addEventListener('click', function() {
      book = t.dataset.bookSelect;
      update();
      if (typeof gtag === 'function') gtag('event', 'select_book', { event_label: book });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'select_book', book: book });
    });
  });

  formatTiles.forEach(function(t) {
    t.addEventListener('click', function() {
      plan = t.dataset.plan;
      update();
      if (typeof gtag === 'function') gtag('event', 'select_plan', { event_label: plan, value: plan === 'digital' ? 5 : 11.99 });
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'select_plan', plan: plan });
    });
  });

  ctaBtn.addEventListener('click', function() {
    var key = book + '-' + plan;
    var variantId = variants[key];
    ctaBtn.textContent = 'Adding to cart...';
    ctaBtn.disabled = true;

    if (typeof gtag === 'function') gtag('event', 'begin_checkout', { event_label: key, value: plan === 'digital' ? 5 : 11.99, currency: 'USD' });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'begin_checkout', book: book, plan: plan });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    }).then(function() {
      window.location.href = '/checkout';
    }).catch(function() {
      ctaBtn.textContent = 'Something went wrong — try again';
      ctaBtn.disabled = false;
    });
  });

  function openModal(selectedBook) {
    // Study Turtle removed - force hoots even if an old data-book="turtle" trigger remains
    if (selectedBook && variants[selectedBook + '-' + plan]) book = selectedBook;
    else book = 'hoots';
    update();
    backdrop.classList.add('hh-modal-open');
    document.body.style.overflow = 'hidden';
    if (typeof gtag === 'function') gtag('event', 'product_modal', { event_label: 'open', book: book });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'product_modal', book: book });
  }

  function closeModal() {
    backdrop.classList.remove('hh-modal-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function(e) {
    var trigger = e.target.closest('[data-open-buy-modal]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.dataset.book || 'hoots');
    }
  });

  modal.querySelector('.close-btn').addEventListener('click', closeModal);
  backdrop.addEventListener('click', function(e) { if (e.target === backdrop) closeModal(); });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape') closeModal(); });

  update();
})();
